import React from 'react';
import styled from 'styled-components';

import Column from './Column';
import Row from './Row';

const LoadingRow = styled(Row)`
  text-align: center;
  color: ${props => props.theme.palette.text.secondary};
`;

LoadingRow.defaultProps = {
  children: <Column>Ladataan...</Column>
};

export default LoadingRow;
